angular
    .module("index.controller")
    .controller('commonPopup', ['$scope', '$element', '$document', '$timeout', function ($scope, $element, $document, $timeout) {
        //Modal focus behavior
        var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
            'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
            'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';

        $scope.popupUrl = '';
        $scope.showHeader = true;

        $scope.showEMLLogo = false;
        $scope.IsInternalLogin = sessionStorage.UserRole !== undefined && sessionStorage.UserRole !== "";

        $scope.showCloseButton = true;
        $scope.closePopUp = function (def) {
            $scope.popupUrl = '';
            if (!!def) {
                def.resolve();
            }
        };

        $scope.$on('show-common-popup', function (event, options, url) {
            if (!!url) {
                $scope.popupUrl = url;
            }
            if (!!options) {
                $scope.showHeader = options.showHeader === undefined ? true : options.showHeader;
                $scope.showCloseButton = options.showCloseButton === undefined ? true : options.showCloseButton;
                $scope.showEMLLogo = options.showEMLLogo === undefined ? false : options.showHeader;
            }

            var additionClass = !!options.additionClass ? options.additionClass : '';

            $scope.theme = function () {
                return (!!options && !!options.otherTheme ? 'resetPasswordForm' : '') + additionClass;
            }

            _.assign($scope, options);
            $timeout(function () {
                // _.assign($scope, options);
                $document.on('keydown', keydownListener);
            });
        });

        $scope.$on('hide-common-popup', function (event, def) {
            $scope.closePopUp(def);
        });
        function isVisible(element) {
            return !!(element.offsetWidth ||
                element.offsetHeight ||
                element.getClientRects().length);
        }

        function isFocusOutsideModal(evt, list) {
            if (list.length > 0) {
                var element = evt.target;
                if (element) {
                    return list.indexOf(element) < 0;
                }
            }
            return false;
        }

        $scope.loadFocusElementList = function () {
            var elements = $element[0].querySelectorAll(tabbableSelector);
            return elements ?
                Array.prototype.filter.call(elements, function (element) {
                    return isVisible(element);
                }) : elements;
        }

        $scope.isFocusInFirstItem = function (evt, list) {
            if (list.length > 0) {
                return (evt.target || evt.srcElement) === list[0];
            }
            return false;
        };

        $scope.isFocusInLastItem = function (evt, list) {
            if (list.length > 0) {
                return (evt.target || evt.srcElement) === list[list.length - 1];
            }
            return false;
        };

        $scope.focusLastFocusableElement = function (list) {
            if (list.length > 0) {
                list[list.length - 1].focus();
                return true;
            }
            return false;
        };

        $scope.focusFirstFocusableElement = function (list) {
            if (list.length > 0) {
                list[0].focus();
                return true;
            }
            return false;
        };

        $scope.isModalFocused = function (evt) {
            if (evt) {
                return (evt.target || evt.srcElement) === $element[0];
            };
            return false;
        };

        function keydownListener(evt) {
            if (evt.isDefaultPrevented()) {
                return evt;
            }

            switch (evt.which) {
                case 9: {
                    var list = $scope.loadFocusElementList();
                    var focusChanged = false;
                    if (evt.shiftKey) {
                        if ($scope.isFocusInFirstItem(evt, list) || $scope.isModalFocused(evt)) {
                            focusChanged = $scope.focusLastFocusableElement(list);
                        }
                    } else {
                        if ($scope.isFocusInLastItem(evt, list) || isFocusOutsideModal(evt, list)) {
                            focusChanged = $scope.focusFirstFocusableElement(list);
                        }
                    }

                    if (focusChanged) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }

                    break;
                }
            }
        }
    }]);
